import { CurrencyIcon } from '@repo/ui/currency-icon';
import { Skeleton } from '@repo/ui/skeleton';
import { useTranslations } from 'next-intl';
import React, { type ReactNode } from 'react';
import { PAYMENT_TYPES } from '@/constants';
import { type FullMethod } from '@/hooks/usePaymentMethodsWithNetworks';

// import WithdrawLimitsInfo, { useWithdrawLimits } from '@/app/[locale]/(account)/account/components/withdraw-limits-info';

// import WithdrawLimitsInfo, { useWithdrawLimits } from '@/app/[locale]/(account)/account/components/withdraw-limits-info';

type WithdrawCryptoDetailsHeaderProps = {
  selectedMethod?: FullMethod;
  backButtonRenderer?: ReactNode;
};

const WithdrawCryptoDetailsHeader = ({ selectedMethod, backButtonRenderer }: WithdrawCryptoDetailsHeaderProps) => {
  const t = useTranslations(PAYMENT_TYPES.WITHDRAWALS);
  // const { data: limits, isLoading: isLimitsLoading } = useWithdrawLimits();

  return (
    <div className="flex w-full items-center justify-between border-b border-[var(--surface-lighter-bg)] py-2.5">
      <div className="flex w-1/2 items-center justify-center font-bold vt-text-size-bigger">
        {backButtonRenderer}
        <div className="flex w-full items-center justify-start space-x-2 rtl:space-x-reverse">
          {selectedMethod?.currencyCode ? (
            <CurrencyIcon
              className="size-5"
              currency={selectedMethod?.currencyCode?.toLowerCase()}
            />
          ) : (
            <Skeleton className="size-5 rounded-full p-3.5" />
          )}
          {selectedMethod?.currencyCode ? (
            <span>{t('payment-type')}</span>
          ) : (
            <Skeleton className="h-5 w-20 rounded p-3.5" />
          )}
        </div>
      </div>
      {/*<div className="w-1/2 text-right">*/}
      {/*  <WithdrawLimitsInfo*/}
      {/*    limits={limits!}*/}
      {/*    isLoading={isLimitsLoading}*/}
      {/*  />*/}
      {/*</div>*/}
    </div>
  );
};

export default WithdrawCryptoDetailsHeader;
